import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSegment } from '@sparknz/journeys-common';

import { useWearableDevice } from 'journey/productDetails/components/ProductConfigurator/hooks';
import { useProductDetails } from 'journey/productDetails/provider';
import { extractFirstValue } from 'shared/utils';
import { trackAccountSelectorActionLayer } from './trackAccountSelectorActionLayer';

const ACTION_LAYER_EVENT_NAME = {
  ifp: 'Shop Mobile Plan Selector Action Layer',
  wearable: 'Shop Wearable Plan Selector Action Layer',
};

export default function useTrackAccountSelectorActionLayer() {
  const router = useRouter();

  const { selectedDevice, paymentOptions } = useProductDetails();
  const { isBusiness } = useSegment();
  const { isWearableEligibilityCheckRequired } = useWearableDevice();
  const ifpId = extractFirstValue(router.query.ifpId);

  useEffect(() => {
    trackAccountSelectorActionLayer({
      eventInfo: {
        eventName: isWearableEligibilityCheckRequired
          ? ACTION_LAYER_EVENT_NAME.wearable
          : ACTION_LAYER_EVENT_NAME.ifp,
        eventAction: 'actionLayer.view',
      },
      device: selectedDevice,
      paymentOption: paymentOptions?.find(({ id }) => id === ifpId),
      isBusiness,
    });
  }, []);
}
